import type { ICreateDraftOrder, IPaymentParam } from "../interface/draft-order";
import type { Cart } from "../types/storefront.types";

const KR_API_URL = {
  thisisneverthat: "https://dycbkwm4xaqdzyb3ebq4onnqqu0cvcxb.lambda-url.ap-northeast-2.on.aws/",
  yeseyesee: "https://xe4cpjkt23o6h33gblqgm23jry0bzdpi.lambda-url.ap-northeast-2.on.aws/",
  khakis: "https://slrbjbhohxpahm3qnhkfhuwigm0cfxii.lambda-url.ap-northeast-2.on.aws/",
  tune: "https://w5345hyzyumpvcpvvo4rtkt2hy0eulsx.lambda-url.ap-northeast-2.on.aws/",
  sunlove: "https://ardejr3kdpsid2ziwmvzlrhfe40jhfox.lambda-url.ap-northeast-2.on.aws/",
  wellbeingexpress: "https://kmexnw5mhbpbrxfr27vfc6vxsy0nfktm.lambda-url.ap-northeast-2.on.aws/",
  tenui: "https://ztr2gdcxi44thxi73cbcywmhwq0ffxza.lambda-url.ap-northeast-2.on.aws/",
};

const INTL_API_URL = {
  thisisneverthat: "https://ccazobvdblbbieaobs6hbo67ue0uzwsm.lambda-url.ap-northeast-2.on.aws/ ",
  yeseyesee: "https://3mqdb2gvqk6ccm53vldx3jb2ue0sodaa.lambda-url.ap-northeast-2.on.aws/",
  tune: "",
  khakis: "https://jecqa33s6w2qi375wuxz2saoai0ydgmx.lambda-url.ap-northeast-2.on.aws/",
  sunlove: "https://ovjqd3e26cekkyzi2riy43ucfm0qlhvy.lambda-url.ap-northeast-2.on.aws/",
  wellbeingexpress: "",
  tenui: "",
};

interface IProps {
  shop: string;
  domain: "ko" | "en" | "jp";
  param: IPaymentParam & {
    paymentKey: string;
    orderId: string;
    amount: number;
    brandPay?: string;
    cartId?: string;
    cart?: Cart;
  };
  useTestClientKey?: boolean; // toss 테스트 키 사용 여부 true이면 테스트 키 사용, false이면 고유 키 사용
}

export const createDraftOrder = async ({
  shop,
  domain,
  param,
  useTestClientKey = false,
}: IProps): Promise<{ status: number; data: ICreateDraftOrder } | undefined> => {
  const apiUrl = domain === "ko" ? KR_API_URL : INTL_API_URL;
  const lambdaUrl = apiUrl[shop as keyof typeof apiUrl];
  if (!lambdaUrl) return;

  try {
    const response = await fetch(lambdaUrl, {
      method: "POST",
      body: JSON.stringify({ ...param, ...(useTestClientKey && { useTestClientKey: true }) }),
    }).then((res) => res);
    const data = (await response.json()) as ICreateDraftOrder;
    return { status: response.status, data };
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
